import { combineReducers } from '@reduxjs/toolkit'
import bundle from './bundleSlice'

const reducer = combineReducers({
    bundle,
})

export default reducer
